export const FETCH_DASHBOARD_STATS = "FETCH_DASHBOARD_STATS";
export const SET_DASHBOARD_STATS = "SET_DASHBOARD_STATS";
export const SET_DASHBOARD_STATS_ERROR = "SET_DASHBOARD_STATS_ERROR";
